// extracted by mini-css-extract-plugin
export default {"dropdownIcon":"CardSelect_dropdownIcon--n6c"};